import { ApiClient } from '@/shared/api/client';
import type { DataQueryResponse } from '@/features/data-query/types';

export interface DataQueryListQuery {
  readonly from: string;
  readonly to: string;
  readonly requester?: string;
  readonly outcome?: string;
  readonly page: number;
  readonly size: number;
}

export class DataQueryApi {
  static fetch(query: DataQueryListQuery): Promise<DataQueryResponse> {
    const params = new URLSearchParams();
    Object.entries(query).forEach(([key, value]) => { if (value) params.set(key, String(value)); });
    return ApiClient.getJson<DataQueryResponse>(`/data-query/executions?${params.toString()}`);
  }
}
